import React from 'react';

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.facebook.com/hiacao1811/" 
                className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/hiacao_1811/?hl=en" 
                className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/in/haicaoxuan/"
                className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-linkedin"></i>
            </a>    
            <a href="https://github.com/SShindow" 
                className="home__social-icon" target="_blank" rel="noreferrer">
                <i class="uil uil-github"></i>
            </a>
            
        </div>
    )
}

export default Social;